import { brandPalette } from "../../../../constants/brandPalette";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Image,
  Input,
  Radio,
  RadioGroup,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
  adminSelectStyles,
} from "../../../../components/Models/admin-modal-theme";
import { getAllChaptersRequest } from "../../../../modules/admin-modules/chapters/Actions";
import { getAllExamsRequest } from "../../../../modules/admin-modules/exams/Actions";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
import { closeCreateVideos } from "../../../../modules/admin-modules/models/Actions";
import {
  createVideoRequest,
  editVideoRequest,
  getPaymentSubjectRequest,
} from "../../../../modules/admin-modules/videos/Actions";
const AddVideo = ({ isAdd, data, setSelectedData }) => {
  const openVideo = useSelector((state) => state.model.isOpen5);
  const isLoading = useSelector((state) => state.videos.isLoading);
  const chapters = useSelector((state) => state.chapters.chapters);
  const groups = useSelector((state) => state.groups.groups);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);
  const exams = useSelector((state) => state.exams.exams);

  const [totalPlayed, setTotalPlayed] = useState(true);
  const [thumbLabel, setThumbLabel] = useState("");
  const [thumbPreview, setThumbPreview] = useState("");

  // Calculate one week from now for default expiry date
  const oneWeekFromNow = dayjs().add(1, 'week').format('YYYY-MM-DDTHH:mm');

  const dispatch = useDispatch();
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data
      ? {
          ...data,
          title: data?.title,
          video_type:
            data?.video_type != null ? String(data.video_type) : "1",
          type: data?.type != null ? String(data.type) : "1",
          publish: data?.publish != null ? String(data.publish) : "1",
          related_to_homework:
            data?.related_to_homework != null
              ? String(data.related_to_homework)
              : "0",
          auto_controlled:
            data?.auto_controlled != null
              ? String(data.auto_controlled)
              : "2",
          total_played:
            data?.total_played != null ? data.total_played : 2,
        }
      : {
          publish: "1",
          video_type: "1",
          auto_controlled: "2",
          type: "1",
          related_to_homework: "0",
          total_played: 2,
          over_view: "over view",
          expiry_date: oneWeekFromNow,
        },
    shouldUnregister: true,
  });
  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const chaptersOptions = chapters?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const paymentSubjectsOptions = paymentSubjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const examsOptions = exams?.map((data) => {
    return { value: data.id, label: data.name };
  });

  useEffect(() => {
    if (openVideo) {
      if (chapters.length == 0) dispatch(getAllChaptersRequest());
      if (groups.length == 0) dispatch(getAllGroupsRequest());
      dispatch(getPaymentSubjectRequest());
      dispatch(getAllExamsRequest());
    }
  }, [openVideo]);

  useEffect(() => {
    if (!openVideo) return;
    if (data) {
      const ac = data.auto_controlled;
      setTotalPlayed(ac === 2 || String(ac) === "2");
      // Ensure edit payload always has chapter_id even if user doesn't change the select.
      const chapterId = data?.chapter_id ?? data?.chapter?.id;
      if (chapterId != null) setValue("chapter_id", chapterId);
    } else {
      setTotalPlayed(true);
    }
  }, [openVideo, data]);

  useEffect(() => {
    return () => {
      if (thumbPreview) URL.revokeObjectURL(thumbPreview);
    };
  }, [thumbPreview]);

  const selectStyles = adminSelectStyles();

  const sectionShell = {
    borderRadius: "12px",
    border: "1px solid rgba(216, 206, 195, 0.65)",
    bg: "rgba(255, 255, 255, 0.38)",
    p: { base: 4, md: 5 },
  };

  const sectionLabel = (label) => (
    <Text
      fontSize="xs"
      fontWeight="800"
      color="rgba(69, 11, 17, 0.55)"
      textTransform="uppercase"
      letterSpacing="0.12em"
      mb={3}
    >
      {label}
    </Text>
  );

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color={brandPalette.primary}
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add Session Video" : "Edit Session Video"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="rgba(69, 11, 17, 0.6)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        URL, chapter, groups, and publishing options
      </Text>
    </Box>
  );
  const onSubmit = async (values) => {
    const newDate = dayjs(data?.expiry_date).format("YYYY-MM-DD");

    const action = () => {
      dispatch(closeCreateVideos());
      reset();
      setTotalPlayed(false);
      setThumbLabel("");
      if (thumbPreview) URL.revokeObjectURL(thumbPreview);
      setThumbPreview("");
      setSelectedData(() => { });
    };
    if (isAdd) {
      if (!values?.chapter_id || values?.groups?.length == 0) {
        toast.error("chapter and groups required");
      } else {
        let formData = new FormData();
        formData.append("expiry_date", newDate);

        for (let key in values) {
          if (key == "groups") {
            values[key]?.map((val, idx) =>
              formData.append(`groups[${idx}]`, val)
            );
          } else if (key === "thumbnail") {
            // handled below (to avoid duplicate append)
          } else if (values[key]) {
            formData.append(key, values[key]);
          }
        }

        // Thumbnail image (optional).
        if (values?.thumbnail instanceof File) {
          formData.set("thumbnail", values.thumbnail);
        }
        dispatch(createVideoRequest(formData, action));
      }
    } else {
      let formData = new FormData();
      formData.append("_method", "PUT");
      const totel = { ...data, ...values };
      const skip = new Set([
        "id",
        "chapter",
        "groups",
        "created_at",
        "updated_at",
        "payment_subject",
        "views_count",
        "views",
        "files",
        "thumbnail",
        "image",
      ]);
      for (let key in totel) {
        if (skip.has(key)) continue;
        if (totel[key] !== null && totel[key] !== undefined && totel[key] !== "" && totel[key] !== " ") {
          const v = totel[key];
          // Avoid serializing nested objects into "[object Object]"
          if (typeof v === "object" && !(v instanceof File) && !Array.isArray(v)) continue;
          formData.append(key, v);
        }
      }

      // Groups are required by backend: send IDs (keep previous if unchanged)
      const groupsValue =
        values?.groups && values.groups.length ? values.groups : data?.groups;
      if (Array.isArray(groupsValue)) {
        groupsValue.forEach((val, idx) => {
          const id = typeof val === "object" ? val?.id : val;
          if (id != null && id !== "") formData.append(`groups[${idx}]`, id);
        });
      }

      // Always pass chapter_id on edit (backend expects id, not chapter object)
      const chapterId = values?.chapter_id ?? data?.chapter_id ?? data?.chapter?.id;
      if (chapterId != null) formData.set("chapter_id", chapterId);

      // Thumbnail image (optional).
      if (values?.thumbnail instanceof File) {
        formData.set("thumbnail", values.thumbnail);
      }
      dispatch(
        editVideoRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateVideos());
    setSelectedData(() => { });
    setThumbLabel("");
    if (thumbPreview) URL.revokeObjectURL(thumbPreview);
    setThumbPreview("");
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openVideo}
      buttonTitle={null}
      buttonFunc={handleSubmit(onSubmit)}
      size="4xl"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      hideDefaultFooter
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={4} dir="ltr" w="100%">
          <Box {...sectionShell}>
            {sectionLabel("Basic details")}
            <SimpleGrid
              columns={{ base: 1, md: 2 }}
              spacingX={8}
              spacingY={4}
              alignItems="start"
            >
              <MainInput
                label="Video title *"
                defaultValues={data?.title}
                error={errors?.title?.message}
                placeholder="Session title"
                register={register}
                name="title"
              />
              <MainInput
                type="datetime-local"
                label="Expiry date"
                defaultValues={dayjs(oneWeekFromNow).format("YYYY-MM-DDThh:mm")}
                error={errors?.expiry_date?.message}
                placeholder="Expiry"
                register={register}
                name="expiry_date"
              />
              <Box gridColumn={{ base: "auto", md: "1 / -1" }}>
                <MainInput
                  label="Video URL *"
                  defaultValues={data?.url}
                  error={errors?.url?.message}
                  placeholder="https://..."
                  register={register}
                  name="url"
                />
              </Box>

              <FormControl gridColumn={{ base: "auto", md: "1 / -1" }}>
                <VStack align="stretch" spacing={2}>
                  <FormLabel
                    m={0}
                    fontSize="14px"
                    fontWeight="700"
                    color={brandPalette.primary}
                    textAlign="left"
                  >
                    Thumbnail image (optional)
                  </FormLabel>
                  <Button
                    bg={brandPalette.primary}
                    color="white"
                    borderRadius="lg"
                    position="relative"
                    h="42px"
                    fontWeight="700"
                    _hover={{ bg: brandPalette.accentDark }}
                  >
                    <Text noOfLines={1}>
                      {thumbLabel || "Choose thumbnail to upload"}
                    </Text>
                    <Input
                      type="file"
                      accept="image/*"
                      opacity="0"
                      position="absolute"
                      w="100%"
                      h="100%"
                      left={0}
                      top={0}
                      cursor="pointer"
                      onChange={(e) => {
                        const f = e.target.files?.[0];
                        if (!f) return;
                        setValue("thumbnail", f);
                        setThumbLabel(f.name);
                        const nextUrl = URL.createObjectURL(f);
                        if (thumbPreview) URL.revokeObjectURL(thumbPreview);
                        setThumbPreview(nextUrl);
                      }}
                    />
                  </Button>

                  {thumbPreview ? (
                    <Box
                      borderWidth="1px"
                      borderColor={brandPalette.stone}
                      borderRadius="12px"
                      overflow="hidden"
                      bg="white"
                      maxW="420px"
                    >
                      <Image
                        src={thumbPreview}
                        alt="Thumbnail preview"
                        w="100%"
                        h="180px"
                        objectFit="cover"
                      />
                    </Box>
                  ) : null}
                </VStack>
              </FormControl>
              <Box gridColumn={{ base: "auto", md: "1 / -1" }}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                  textAlign="left"
                >
                  Overview
                </FormLabel>
                <Textarea
                  mt={2}
                  rows={3}
                  bg={brandPalette.cream}
                  borderRadius="12px"
                  border="1px solid"
                  borderColor={brandPalette.stone}
                  defaultValue={data?.over_view}
                  placeholder="Short description of the content"
                  {...register("over_view", { required: false })}
                  name="over_view"
                />
              </Box>
            </SimpleGrid>
          </Box>

          <Box {...sectionShell}>
            {sectionLabel("Course assignment")}
            <SimpleGrid
              columns={{ base: 1, md: 2 }}
              spacingX={8}
              spacingY={4}
              alignItems="start"
            >
              <FormControl>
                <VStack align="stretch" spacing={2}>
                  <FormLabel
                    m={0}
                    fontSize="14px"
                    fontWeight="700"
                    color={brandPalette.primary}
                    textAlign="left"
                  >
                    Chapter *
                  </FormLabel>
                  <Select
                    options={chaptersOptions}
                    defaultValue={{
                      label: data?.chapter?.name,
                      value: data?.chapter?.id,
                    }}
                    onChange={(d) => setValue("chapter_id", d.value)}
                    styles={selectStyles}
                    placeholder="Select chapter"
                  />
                </VStack>
              </FormControl>
              <FormControl>
                <VStack align="stretch" spacing={2}>
                  <FormLabel
                    m={0}
                    fontSize="14px"
                    fontWeight="700"
                    color={brandPalette.primary}
                    textAlign="left"
                  >
                    Payment session
                  </FormLabel>
                  <Select
                    key={`payment-subject-${paymentSubjectsOptions?.length || 0}`}
                    options={paymentSubjectsOptions || []}
                    defaultValue={
                      paymentSubjectsOptions && data?.payment_subject_id
                        ? {
                            label: paymentSubjectsOptions.find(
                              (val) => val.value == data?.payment_subject_id
                            )?.label,
                            value: data?.payment_subject_id,
                          }
                        : undefined
                    }
                    onChange={(d) => setValue("payment_subject_id", d.value)}
                    styles={selectStyles}
                    placeholder="Payment subject"
                    isLoading={!paymentSubjectsOptions}
                  />
                </VStack>
              </FormControl>
              <FormControl gridColumn={{ base: "auto", md: "1 / -1" }}>
                <VStack align="stretch" spacing={2}>
                  <FormLabel
                    m={0}
                    fontSize="14px"
                    fontWeight="700"
                    color={brandPalette.primary}
                    textAlign="left"
                  >
                    Groups *
                  </FormLabel>
                  <Select
                    options={groupsOptions}
                    isMulti
                    defaultValue={data?.groups?.map((val) => ({
                      label: val?.name,
                      value: val?.id,
                    }))}
                    onChange={(d) => {
                      const selectedGroups = d.map((val) => val.value);
                      setValue("groups", selectedGroups);
                    }}
                    styles={selectStyles}
                    placeholder="Select groups"
                  />
                </VStack>
              </FormControl>
            </SimpleGrid>
          </Box>

          <Box {...sectionShell}>
            {sectionLabel("Player & placement")}
            <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={8} spacingY={3}>
              <Box>
                <FormLabel
                  m={0}
                  mb={2}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                >
                  Player / source
                </FormLabel>
                <Controller
                  name="video_type"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <RadioGroup
                      {...field}
                      value={
                        field.value != null && field.value !== ""
                          ? String(field.value)
                          : undefined
                      }
                      onChange={(v) => field.onChange(v)}
                    >
                      <Stack direction="row" flexWrap="wrap" spacing={3}>
                        <Radio value="0" size="md">
                          YouTube (restricted)
                        </Radio>
                        <Radio value="1" size="md">
                          VDO
                        </Radio>
                        <Radio value="2" size="md">
                          YouTube
                        </Radio>
                        <Radio value="3" size="md">
                          Vimeo
                        </Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                />
              </Box>
              <Box>
                <FormLabel
                  m={0}
                  mb={2}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                >
                  Placement
                </FormLabel>
                <Controller
                  name="type"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <RadioGroup
                      {...field}
                      value={
                        field.value != null && field.value !== ""
                          ? String(field.value)
                          : undefined
                      }
                      onChange={(v) => field.onChange(v)}
                    >
                      <Stack direction="row" flexWrap="wrap" spacing={3}>
                        <Radio value="1" size="md">
                          Edutopia
                        </Radio>
                        <Radio value="7" size="md">
                          Edutopia Practice
                        </Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                />
              </Box>
            </SimpleGrid>
          </Box>

          <Box {...sectionShell}>
            {sectionLabel("Visibility & limits")}
            <SimpleGrid
              columns={{ base: 1, md: 2 }}
              spacingX={8}
              spacingY={4}
            >
              <Box>
                <FormLabel
                  m={0}
                  mb={2}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                >
                  Published
                </FormLabel>
                <Controller
                  name="publish"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <RadioGroup
                      {...field}
                      value={
                        field.value != null && field.value !== ""
                          ? String(field.value)
                          : undefined
                      }
                      onChange={(v) => field.onChange(v)}
                    >
                      <Stack direction="row" flexWrap="wrap" spacing={3}>
                        <Radio value="0" size="md">
                          Hidden
                        </Radio>
                        <Radio value="1" size="md">
                          Published
                        </Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                />
              </Box>
              <Box>
                <FormLabel
                  m={0}
                  mb={2}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                >
                  Homework link
                </FormLabel>
                <Controller
                  name="related_to_homework"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <RadioGroup
                      {...field}
                      value={
                        field.value != null && field.value !== ""
                          ? String(field.value)
                          : undefined
                      }
                      onChange={(v) => field.onChange(v)}
                    >
                      <Stack direction="row" flexWrap="wrap" spacing={3}>
                        <Radio value="1" size="md">
                          Has homework
                        </Radio>
                        <Radio value="0" size="md">
                          No homework
                        </Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                />
              </Box>
            </SimpleGrid>

            <Box mt={4}>
              <FormLabel
                m={0}
                mb={2}
                fontSize="14px"
                fontWeight="700"
                color={brandPalette.primary}
              >
                View limits
              </FormLabel>
              <HStack
                align="flex-start"
                flexWrap="wrap"
                gap={{ base: 3, md: 4 }}
                spacing={0}
              >
                <Controller
                  name="auto_controlled"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <RadioGroup
                      {...field}
                      value={
                        field.value != null && field.value !== ""
                          ? String(field.value)
                          : undefined
                      }
                      onChange={(v) => {
                        field.onChange(v);
                        setTotalPlayed(v === "2");
                      }}
                    >
                      <Stack
                        direction="row"
                        flexWrap="wrap"
                        spacing={3}
                        flex="1"
                        minW="0"
                      >
                        <Radio value="0" size="md">
                          Not limited
                        </Radio>
                        <Radio value="1" size="md">
                          Limited views
                        </Radio>
                        <Radio value="2" size="md">
                          Controlled views
                        </Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                />
                {totalPlayed && (
                  <Box flexShrink={0} w={{ base: "100%", sm: "140px" }}>
                    <FormLabel
                      m={0}
                      mb={1}
                      fontSize="xs"
                      fontWeight="700"
                      color="rgba(69, 11, 17, 0.65)"
                    >
                      Play count
                    </FormLabel>
                    <Input
                      {...register("total_played", { valueAsNumber: true })}
                      bg={brandPalette.cream}
                      borderRadius="12px"
                      borderWidth="1px"
                      borderColor={brandPalette.stone}
                      size="sm"
                      type="number"
                      min={1}
                      placeholder="Count"
                    />
                  </Box>
                )}
              </HStack>
            </Box>

            <FormControl mt={5}>
              <VStack align="stretch" spacing={2}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                  textAlign="left"
                >
                  Post-session exam (optional)
                </FormLabel>
                <Select
                  options={examsOptions}
                  defaultValue={{
                    label: data?.name,
                    value: data?.id,
                  }}
                  onChange={(formData) =>
                    setValue("post_exam_id", formData.value)
                  }
                  styles={selectStyles}
                  placeholder="Select follow-up exam"
                />
              </VStack>
            </FormControl>
          </Box>

          <Flex
            justify="flex-end"
            gap={6}
            pt={4}
            borderTop="1px solid rgba(216, 206, 195, 0.55)"
          >
            <Button
              variant="ghost"
              color={brandPalette.accentDark}
              fontWeight="800"
              _hover={{ textDecoration: "underline" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg={brandPalette.primary}
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: brandPalette.accentDark }}
              boxShadow="0 10px 24px rgba(91, 13, 22, 0.18)"
            >
              Save Changes
            </Button>
          </Flex>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddVideo;
